import React from 'react';
import { Box, Stack } from '@mui/material';

import Icon from '@/components/icons/Icon';

type ArrowProps = {
  currentSlide?: number;
  onClick: () => void;
};

function PrevArrowButton({ currentSlide, onClick }: ArrowProps): JSX.Element {
  if (currentSlide + 1 === 1) {
    return null;
  }

  return (
    <Stack
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '180px',
        height: '100%',
        padding: '1.25rem 0',
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          position: 'relative',
          background: {
            lg:
              'linear-gradient(90deg, #E5EDF8 17.71%, rgba(229, 237, 248, 0.48) 46.87%, rgba(229, 237, 248, 0) 100%)',
          },
        }}
      >
        <Box
          component="button"
          onClick={onClick}
          sx={{
            position: 'absolute',
            top: '53px',
            borderRadius: '50%',
            backgroundColor: '#fff',
            display: 'flex !important',
            padding: '10px',
            boxShadow: '0px 6px 8px 0px #00000040',
          }}
        >
          <Icon
            iconName="arrow-left"
            style={{
              width: '24px',
              height: '24px',
              color: '#B0B2BB',
            }}
          />
        </Box>
      </Box>
    </Stack>
  );
}

export default PrevArrowButton;
